import { useEffect } from "react";

/**
 * brand.js — the product's name, in one place.
 *
 * "Tell the Team" is the app. "Vizette" is the company, and the company's
 * name does not belong in the app's chrome: a DSP opening a link sees the
 * product, not the corporation behind it. Every wordmark, page title and
 * "welcome to" string reads from here, so a rename is one edit — which is
 * how this one should have gone.
 */
export const APP_NAME = "Tell the Team";

/**
 * usePageTitle — the browser tab says where you are.
 *
 * Best practice is "<page> · <app>": the app name last, so a row of tabs
 * still reads, and the specific page first, so the one you want stands out.
 * With no page given it falls back to the app name alone. Restores the app
 * name on unmount so a page that sets a title never leaves it behind.
 */
export function usePageTitle(page) {
  useEffect(() => {
    document.title = page ? `${page} · ${APP_NAME}` : APP_NAME;
    return () => { document.title = APP_NAME; };
  }, [page]);
}
